module.exports = __webpack_public_path__ + "static/media/videoicon.553450f3.svg";